import { collection, query, where, onSnapshot, Timestamp } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { financialEventBus } from './eventBus';

let isListening = false;
let unsubscribe: (() => void) | null = null;

export function startFinancialEventsListener(clinicId: string): () => void {
  if (isListening && unsubscribe) {
    console.log('⚠️ [FINANCIAL-EVENTS-LISTENER] Listener já está ativo');
    return unsubscribe;
  }

  console.log('👂 [FINANCIAL-EVENTS-LISTENER] Iniciando listener para clinicId:', clinicId);

  // O primeiro snapshot entrega TODO o histórico como "added": antes, cada login republicava
  // todos os eventos antigos. Só eventos criados a partir de agora (com folga de relógio) valem.
  const startedAtMs = Date.now() - 2 * 60 * 1000;

  const q = query(
    collection(db, 'financial_events'),
    where('clinicId', '==', clinicId)
  );

  unsubscribe = onSnapshot(
    q,
    (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          const eventData = change.doc.data();
          const createdMs =
            typeof eventData.createdAt?.toMillis === 'function' ? eventData.createdAt.toMillis() : 0;
          if (!createdMs || createdMs < startedAtMs) return;
          
          // Publicar evento no eventBus
          financialEventBus.publish({
            type: eventData.type,
            clinicId: eventData.clinicId,
            userId: eventData.userId || 'system',
            version: eventData.version || 1,
            data: eventData.payload || eventData.data || {}
          }).catch((error) => {
            console.error('❌ [FINANCIAL-EVENTS-LISTENER] Erro ao publicar evento:', error);
          });
        }
      });
    },
    (error) => {
      console.error('❌ [FINANCIAL-EVENTS-LISTENER] Erro no listener:', error);
    }
  );

  isListening = true;

  return () => {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = null;
      isListening = false;
      console.log('🛑 [FINANCIAL-EVENTS-LISTENER] Listener parado');
    }
  };
}

export function stopFinancialEventsListener(): void {
  if (unsubscribe) {
    unsubscribe();
    unsubscribe = null;
    isListening = false;
    console.log('🛑 [FINANCIAL-EVENTS-LISTENER] Listener parado');
  }
}

